import { render, staticRenderFns } from "./CardCustom.vue?vue&type=template&id=1c736b7b&scoped=true"
import script from "./CardCustom.vue?vue&type=script&lang=js"
export * from "./CardCustom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c736b7b",
  null
  
)

export default component.exports